module.exports = __webpack_public_path__ + "beads.jpg?1e917650a137d65308b9bf0ff6fc565d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/beads.jpg
// module id = 163
// module chunks = 0